// ¿La plantilla que está abierta elige Calidad (1K / 2K / 4K)?
// ADR-2026-09-28-las-plantillas-eligen-la-calidad.
//
// Una sola regla para los cuatro lugares que la necesitan —la celda del pie
// (`ConfigurePanel`), el multiplicador del pill (`PresetDetailSheet`), el `image_size`
// del payload y el del carrusel de la producción (`InterfazV2`)—: si uno la mira distinto
// que otro, el pill dice un precio y el backend cobra otro.
//
// Sólo las plantillas de IMAGEN. La de video corre sobre Kling, que no tiene resolución
// de imagen que elegir; y la de imagen con la pestaña "Video" genera un cuadro que después
// se anima, así que pagar 4K por ese cuadro no mejora el video.

export function plantillaEligeCalidad(
  preset: { kind?: string | null; outputType?: string | null } | null | undefined,
  /** La pestaña "Video" de la plantilla (`previewMediaTab === 'video'`). */
  modoVideo: boolean,
): boolean {
  return (
    preset?.kind === 'template' && preset.outputType !== 'video' && !modoVideo
  );
}
